import React, { useEffect, useState, useContext, useRef } from 'react';
import * as S from './styles_Repres';
import { Context } from '../../services/contexts/StateContext';
import MaskedInput from 'react-text-mask';
// -----------------------

import { API_Franquia } from '../../services/FiltrosApi/franquiaApi';
// ----------------------------------------

export function FoneCelular({setMostrarModalCelular}) {
    const { state, dispatch } = useContext(Context);
    const { franquia } = state.franquia;

    const { AtualizarFranquia } = API_Franquia();
    // ----------------------

    // Estados para modal de celular
    const [celularDigitado, setCelularDigitado] = useState('');
    const [erroModalCelular, setErroModalCelular] = useState('');
    // ----------------------
    
    // ###################################################

    // Função para salvar celular da franquia
    const salvarCelularFranquia = async () => {
        setErroModalCelular('');

        // Validar se o celular foi digitado
        if (!celularDigitado || celularDigitado.trim() === '') {
            setErroModalCelular('Por favor, digite o número de celular.');
            return;
        }

        // Remover formatação e validar tamanho
        const celularLimpo = celularDigitado.replace(/\D/g, '');
        if (celularLimpo.length < 10 || celularLimpo.length > 11) {
            setErroModalCelular('Número de celular inválido. Digite um número completo.');
            return;
        }

        // Chamar API para atualizar franquia
        const resultado = await AtualizarFranquia(franquia.id, {
            foneCelular: {
                numeroCel: celularDigitado
            }
        });

        if (resultado.success) {
            setMostrarModalCelular(false);
            setCelularDigitado('');
            setErroModalCelular('');
        }
    };

    // Função para fechar modal de celular
    const fecharModalCelular = () => {
        setMostrarModalCelular(false);
        setCelularDigitado('');
        setErroModalCelular('');
    };

    //###################################################################################
    return (
        <>
        <S.div3>
            <div style={{
                display: 'flex',
                marginTop:"10px"
            }}>
                <div style={{
                    backgroundColor: '#262626',
                    border: '1px solid #00D594',
                    borderRadius: '5px',
                    padding: 'clamp(15px, 4vw, 30px)',
                    width: '80vw',
                    maxWidth: '400px',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)'
                }}>
                    <div style={{
                        textAlign: 'center',
                        marginBottom: 'clamp(15px, 3vw, 20px)',
                        borderBottom: '1px solid #3881ff',
                        paddingBottom: '10px'
                    }}>
                        <span style={{
                            color: '#00D594',
                            fontSize: 'clamp(14px, 3.5vw, 18px)',
                            fontWeight: 'bold',
                            display: 'block',
                            marginBottom: '8px'
                        }}>
                            📱 Número de Celular Necessário
                        </span>
                    </div>

                    <div style={{
                        marginBottom: 'clamp(15px, 3vw, 20px)',
                        width: '100%'
                    }}>
                        <span style={{
                            color: '#00D594',
                            fontSize: 'clamp(11px, 3vw, 14px)',
                            fontWeight: 'bold',
                            display: 'block',
                            marginBottom: '8px'
                        }}>
                            Celular:
                        </span>
                        <MaskedInput
                            value={celularDigitado}
                            type='text'
                            placeholder='(00) 00000-0000'
                            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            guide={false}
                            onChange={(e) => {
                                setCelularDigitado(e.target.value);
                                setErroModalCelular('');
                            }}
                            style={{
                                width: '90%',
                                padding: 'clamp(8px, 2vw, 12px)',
                                fontSize: 'clamp(12px, 3vw, 16px)',
                                borderRadius: '3px',
                                border: erroModalCelular ? '2px solid #ff4444' : '1px solid #3881ff',
                                backgroundColor: '#353535',
                                color: 'white',
                                outline: 'none',
                                height: '30px'
                            }}
                            autoFocus
                        />
                    </div>

                    {erroModalCelular && (
                        <div style={{
                            color: '#ff4444',
                            fontSize: 'clamp(11px, 2.5vw, 13px)',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'rgba(255, 68, 68, 0.1)',
                            padding: '10px',
                            borderRadius: '3px',
                            marginBottom: '15px',
                            border: '1px solid #ff4444'
                        }}>
                            ❌ {erroModalCelular}
                        </div>
                    )}

                    <div style={{
                        display: 'flex',
                        gap: 'clamp(5px, 2vw, 10px)',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        width: '100%'
                    }}>
                        <button
                            type='button'
                            onClick={salvarCelularFranquia}
                            style={{
                                backgroundColor: '#00D594',
                                color: '#000',
                                padding: 'clamp(8px, 2vw, 12px) clamp(15px, 4vw, 30px)',
                                fontSize: 'clamp(11px, 3vw, 14px)',
                                fontWeight: 'bold',
                                border: 'none',
                                borderRadius: '3px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                flex: '1',
                                minWidth: '80px',
                                height: 'clamp(30px, 5vw, 40px)',
                                alignItems: "center",
                                justifyContent:"center",
                                display: "flex"
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#00ff9d';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#00D594';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            ✓ SALVAR
                        </button>

                        <button
                            type='button'
                            onClick={fecharModalCelular}
                            style={{
                                backgroundColor: '#f0433d',
                                color: '#fff',
                                padding: 'clamp(8px, 2vw, 12px) clamp(15px, 4vw, 30px)',
                                fontSize: 'clamp(11px, 3vw, 14px)',
                                fontWeight: 'bold',
                                border: 'none',
                                borderRadius: '3px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                flex: '1',
                                minWidth: '80px',
                                height: 'clamp(30px, 5vw, 40px)',
                                alignItems: "center",
                                justifyContent:"center",
                                display: "flex"
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#ff6666';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#f0433d';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            ✕ CANCELAR
                        </button>
                    </div>
                </div>
            </div>
        </S.div3>
    </>
    );
}
